/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Hero_Download_SampleInputs */

const en_endpoint_hero_download_sample = /** @type {(inputs: Endpoint_Hero_Download_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download sample`)
};

const zh_hans1_endpoint_hero_download_sample = /** @type {(inputs: Endpoint_Hero_Download_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载示例`)
};

const pt_br2_endpoint_hero_download_sample = /** @type {(inputs: Endpoint_Hero_Download_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar amostra`)
};

const es_endpoint_hero_download_sample = /** @type {(inputs: Endpoint_Hero_Download_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar muestra`)
};

const fr_endpoint_hero_download_sample = /** @type {(inputs: Endpoint_Hero_Download_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger l’exemple`)
};

const de_endpoint_hero_download_sample = /** @type {(inputs: Endpoint_Hero_Download_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beispiel herunterladen`)
};

const ru_endpoint_hero_download_sample = /** @type {(inputs: Endpoint_Hero_Download_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать пример`)
};

const it_endpoint_hero_download_sample = /** @type {(inputs: Endpoint_Hero_Download_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica il campione`)
};

/**
* | output |
* | --- |
* | "Download sample" |
*
* @param {Endpoint_Hero_Download_SampleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_hero_download_sample = /** @type {((inputs?: Endpoint_Hero_Download_SampleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Hero_Download_SampleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_hero_download_sample(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_hero_download_sample(inputs)
	if (locale === "es") return es_endpoint_hero_download_sample(inputs)
	if (locale === "fr") return fr_endpoint_hero_download_sample(inputs)
	if (locale === "de") return de_endpoint_hero_download_sample(inputs)
	if (locale === "ru") return ru_endpoint_hero_download_sample(inputs)
	if (locale === "it") return it_endpoint_hero_download_sample(inputs)
	return en_endpoint_hero_download_sample(inputs)
});